export const DashboardAppTableHeaders = [
  {
    Header: "Appointment Date",
    accessor: "date",
  },
  {
    Header: "Time",
    accessor: "time",
  },
  {
    Header: "Customer Name",
    accessor: "customer",
  },
  {
    Header: "Appointment Type",
    accessor: "type",
  },
  {
    Header: "Phone",
    accessor: "phone",
  },
];

export const AppointmentDailyPrintHeaders = [
  {
    Header: "Time",
    accessor: "time",
  },
  {
    Header: "Customer Name",
    accessor: "customer",
  },
  {
    Header: "Type",
    accessor: "type",
  },
  {
    Header: "Phone",
    accessor: "phone",
  },
  {
    Header: "Description",
    accessor: "description",
  },
  {
    Header: "Done",
    accessor: "select",
  },
];

export const AppointmentSearchHeaders = [
  {
    Header: "Date",
    accessor: "date"
  },
  {
    Header: "Time",
    accessor: "time",
  },
  {
    Header: "Customer Name",
    accessor: "customer",
  },
  {
    Header: "Type",
    accessor: "type",
  },
  {
    Header: "Phone",
    accessor: "phone",
  },
  {
    Header: "Description",
    accessor: "description",
  },
  {
    Header: "Done",
    accessor: "select",
  },
];

export const DashboardAppMiniTableHeaders = [

  {
    Header: "Time",
    accessor: "time",
  },
  {
    Header: "Customer Name",
    accessor: "customer",
  },
  {
    Header: "Appointment Type",
    accessor: "type",
  },
  {
    Header: "Description",
    accessor: "description",
  },
];
